import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Button, If, Text } from 'src/Components'

import styles from './Subscription.module.scss'

const propTypes = {
  isSubscribed: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isBuyer: PropTypes.bool
}

const Subscription = ({ isSubscribed, onSubmit, isBuyer }) => (
  <div className={classnames('card card--standalone', styles.container)}>
    <Text element='h3' weight='light' size='l' paragraph>
      <If condition={isSubscribed}>
        <If condition={isBuyer}>
          <FormattedMessage
            id='Unsubscribe.buyer.headline'
            defaultMessage='Not enjoying your monthly Market report?'
          />
        </If>
        <If condition={!isBuyer}>
          <FormattedMessage
            id='Unsubscribe.homeonwer.headline'
            defaultMessage='Not enjoying your monthly Home Value report?'
          />
        </If>
      </If>
      <If condition={!isSubscribed}>
        <If condition={isBuyer}>
          <FormattedMessage
            id='Subscribe.headline'
            defaultMessage='Get a Homebot Market report in your inbox every month.'
          />
        </If>
        <If condition={!isBuyer}>
          <FormattedMessage
            id='Subscribe.homeowner.headline'
            defaultMessage='Get a Homebot Home Value report in your inbox every month.'
          />
        </If>
      </If>
    </Text>
    <Button
      className={styles.subscriptionLink}
      onClick={onSubmit}
      data-qa={isSubscribed ? 'subscribe-button' : 'unsubscribe-button'}
    >
      <If condition={isSubscribed}>
        <FormattedMessage id='Unsubscribe.link' defaultMessage='Unsubscribe' />
      </If>
      <If condition={!isSubscribed}>
        <If condition={isBuyer}>
          <FormattedMessage
            id='Subscribe.buyer.link'
            defaultMessage='Subscribe to the monthly Market report'
          />
        </If>
        <If condition={!isBuyer}>
          <FormattedMessage
            id='Subscribe.homeowner.link'
            defaultMessage='Subscribe to the monthly Home Value report'
          />
        </If>
      </If>
    </Button>
  </div>
)

Subscription.propTypes = propTypes

export default Subscription
